import React from "react";
import { graphql } from "gatsby";
import Clock from "../icons/clock-three-thin.svg";
import classNames from "classnames";

const BannerNotification = ({ data }) => {
  const backgroundColor = data.color ? data.color : "red";
  const iconName = data.icon ? data.icon?.[0] : "";
  return (
    data.text && (
      <div className="d-flex justify-content-center mb-md-0 mb-2">
        <button
          className={classNames(
            "banner-notification__btn",
            data?.alternativeIcon?.node?.publicURL && "d-flex",
            `banner-notification__btn--${backgroundColor}`
          )}
        >
          {iconName && iconName === "watch" ? (
            <Clock className="icon-svg banner-notification__icon" />
          ) : (
            data?.alternativeIcon?.node?.publicURL && (
              <img
                alt={data?.alternativeIcon?.value?.description}
                src={data.alternativeIcon.node.publicURL}
                style={{
                  "margin-top": "5px",
                  "margin-right": "5px",
                  "color": "#fff",
                  "width": `${data.width ? data.width : "12"}px`,
                  "height": `${data.height ? data.height : "12"}px`,
                }}
              />
            )
          )}
          <span className="banner-notification__text">{data.text}</span>
        </button>
      </div>
    )
  );
};

export default BannerNotification;
export const fragment = graphql`
  fragment BannerNotificationFragment on LiferayNotification {
    skus
    text
    alternativeIcon {
      node {
        publicURL
      }
      value {
        description
      }
    }
    height
    width
    color
    icon
  }
`;
